<!--
	NOTE: we have to jump through some hoops to disable autocomplete on 
	input fields. including setting autocomplete to a bogus value 
	(technically "off" should suffice but Chrome is ignoring it) and making
	sure input element ids, if any, aren't too obvious (e.g., 'toName', 
	'toTel' and 'toAddr' trigger auto-complete). i also went a step further
	and used <div>s instead of <label>s for field labels.
-->

<script>
	export let disabled = false;
	export let help = "";
	export let label;
	export let limits = undefined;
	export let optional = false;
	export let placeholder = "";
	export let type = "text";
	export let validatorFn = () => true;
	export let value;
	export let width = "90%";
	
	let focused;
</script>

<style type="text/scss">
	@import "./style/theme.scss";

	#root {
		margin-bottom: 15px;
		margin-left: auto;
		margin-right: auto;
		margin-top: 15px;
		position: relative;
				
		.label {
			@extend .column-container;
			position: absolute;
			margin-left: 15px;
			pointer-events: none;
			top: 1em;

			&.focused {
				color: $halo-logo-halo-color;
				font-size: 0.8em;
				margin-left: 5px;
				top: -0.15em;
			}
			
			.note {
				font-style: italic;
				font-size: 0.8em;
			}
		}
		
		input, textarea {
			border: none; 
			border-bottom-width: 3px;
			border-bottom-style: solid;
			border-bottom-color: $default-fg-color;
			outline: none;
			padding-top: 1em;
			width: 100%;
			
			&.invalid {
				border-bottom-color: $error-color;
			}
			
			&::-webkit-input-placeholder {
				font-size: 0.8em;
			}
		}
		
		textarea {
			resize: none;
		}
		
		.help {
			color: $error-color;
			font-size: 0.8em;
		}
	}
</style>

<div id="root"
	style="width:{width}">
	<div class="label"
		class:disabled
		class:focused={focused || value}>
		{label}
		{#if optional}
			<span class="note">&nbsp;(optional)</span>
		{/if}
	</div>
	{#if limits}
		<textarea 
			rows=1
			bind:value
			class:disabled
			class:invalid={!validatorFn(value)}
			on:blur={ev => {
				focused = false;
				value = value.trim();
				if( !value )
					ev.target.rows = 1;
			}}
			on:focus={ev => {
				focused = true;
				ev.target.rows = limits.maxLines;
			}}
			on:click|stopPropagation={ev => ev.target.focus()}></textarea>
	{:else if type == 'tel'}
		<input 
			type="tel" 
			autocomplete="nope"
			placeholder={focused ? placeholder : ''}
			bind:value
			class:disabled
			class:invalid={!validatorFn(value)}
			on:blur={ev => {
				focused = false;
				value = value.trim();
			}}
			on:focus={() => focused = true}
			on:click|stopPropagation={ev => ev.target.focus()}>
	{:else}
		<input 
			type="text" 
			autocomplete="nope"
			placeholder={focused ? placeholder : ''}
			bind:value
			class:disabled
			class:invalid={!validatorFn(value)}
			on:blur={ev => {
				focused = false;
				value = value.trim();
			}}
			on:focus={() => focused = true}
			on:click|stopPropagation={ev => ev.target.focus()}>
	{/if}
	{#if help}
		<div class="help"
			class:invisible={validatorFn(value)}>
			{help}
		</div>
	{/if}
</div>
